<section class="section">
<ul class="breadcrumb breadcrumb-style ">
<li class="breadcrumb-item">
<h4 class="page-title m-b-0">Reseller Product Price List</h4>
</li>
<li class="breadcrumb-item">
<a routerLink="/dashboard">
<i data-feather="home"></i></a>
</li>
<li class="breadcrumb-item active">Price in {{totaldatas.def_currency_name}}</li>
</ul>
<div class="section-body">


<div class="row">

<div class="col-12 col-sm-12 col-lg-12">
<div class="card card-primary">
<div class="card-header">
<h4>Reseller Product Price</h4>
<div class="card-header-action">
<a  data-toggle="collapse" class="btn btn-icon btn-info" href="#bankDetails-collapse">
<i class="fas fa-minus"></i></a>
</div>
</div>
<div class="collapse show" id="bankDetails-collapse">
<div class="card-body">

<div class="page-content custom-tab note-has-grid reseller-product-list-tab">
<ul class="nav nav-pills p-3 mb-3 rounded-pill align-items-center">

<li class="nav-item" *ngIf="cxpricelist.length != 0">
<a href="javascript:;" (click)="showactive('cxpricelist')"  [ngClass]="{'active': showingtab === 'cxpricelist'}"
class="tabStartClick nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2 "
id="HTekPhones"><span class="d-md-block">3CX Pricelist - USD - MYR</span></a>
</li>

<li class="nav-item" *ngIf="HtekIPPhones.length != 0">
<a href="javascript:;"   (click)="showactive('HtekIPPhones')"   [ngClass]="{'active': showingtab === 'HtekIPPhones'}"
class="tabStartClick nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2 "
id="HTekPhones"><span class="d-md-block">H-Tek IP Phones</span></a>
</li>

<li class="nav-item" *ngIf="headsets.length != 0">
<a href="javascript:;" (click)="showactive('headsets')" [ngClass]="{'active': showingtab === 'headsets'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2 "
id="headsets"><span class="d-md-block">Headsets</span></a>
</li>

 <li class="nav-item" *ngIf="CXAPPLIANCE3CXSBC.length != 0">
<a href="javascript:;" (click)="showactive('CXAPPLIANCE3CXSBC')" [ngClass]="{'active': showingtab === 'CXAPPLIANCE3CXSBC'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="3CXAppliance"><span class="d-md-block">3CX Applicance - 3CX SBC</span></a>
</li> 

<li class="nav-item"  *ngIf="beronet.length != 0">
<a href="javascript:;" (click)="showactive('beronet')" [ngClass]="{'active': showingtab === 'beronet'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="beronetGateways"><span class="d-md-block">Beronet Gateways</span></a>
</li>

<li class="nav-item"  *ngIf="intercomspasystem.length != 0">
<a href="javascript:;" (click)="showactive('intercomspasystem')" [ngClass]="{'active': showingtab === 'intercomspasystem'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="intercomPA"><span class="d-md-block">Intercoms - PA system</span></a>
</li>
<li class="nav-item"  *ngIf="faxata3cx.length != 0">
<a href="javascript:;" (click)="showactive('faxata')" [ngClass]="{'active': showingtab === 'faxata'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="faxATA"><span class="d-md-block">FAX ATA -3CX</span></a>
</li>
<li class="nav-item" *ngIf="conferencephonewebmeeting.length != 0">
<a href="javascript:;" (click)="showactive('conference')" [ngClass]="{'active': showingtab === 'conference'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="conferencePhone"> 
<span class="d-md-block">CONFERENCE PHONE -3CX WEB MEETING</span></a>
</li>
<li class="nav-item" *ngIf="hotelphones.length != 0">
<a href="javascript:;" (click)="showactive('hotels')" [ngClass]="{'active': showingtab === 'hotels'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="hotelPhones"> 
<span class="d-md-block">Hotel Phones</span></a>
</li>
<li class="nav-item"  *ngIf="siptrunkslocal.length != 0">
<a href="javascript:;" (click)="showactive('siptrunk')" [ngClass]="{'active': showingtab === 'siptrunk'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="hotelPhones"> 
<span class="d-md-block">SIPTRUNKS- LOCAL</span></a>
</li>
 <li class="nav-item" *ngIf="totaldatas.calncall_shopping_page_details.length != 0">
<a  href="javascript:;" (click)="showactive('3cxcloudsg')" [ngClass]="{'active': showingtab === '3cxcloudsg'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="3cxCloudHosting"> 
<span class="d-md-block">3CX CLOUD-Sg - Hosting</span></a>
</li> 
 <li class="nav-item" *ngIf="totaldatas.callacloud_shopping_page_details.length != 0">
<a  href="javascript:;" (click)="showactive('3cxcloudmy')" [ngClass]="{'active': showingtab === '3cxcloudmy'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="3cxCloudHosting"> 
<span class="d-md-block">3CX CLOUD-My - Hosting</span></a>
</li> 
 <li class="nav-item" *ngIf="totaldatas.callnclear_shopping_page_details.length != 0">
<a  href="javascript:;" (click)="showactive('3cxcloudthb')" [ngClass]="{'active': showingtab === '3cxcloudthb'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="3cxCloudHosting"> 
<span class="d-md-block">3CX CLOUD-THB - Hosting</span></a>
</li> 

 <li class="nav-item"  *ngIf="yealink.length != 0">
<a  href="javascript:;" (click)="showactive('yealink')" [ngClass]="{'active': showingtab === 'yealink'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="3cxCloudHosting"> 
<span class="d-md-block">Yea link</span></a>
</li> 
<li class="nav-item" *ngIf="snomipphones.length != 0">
<a href="javascript:;" (click)="showactive('snomip')"  [ngClass]="{'active': showingtab === 'snomip'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="snomIPPhones"> 
<span class="d-md-block">Snom IP Phones</span></a>
</li>
<li class="nav-item" *ngIf="internationaldidprice.length != 0">
<a href="javascript:;" (click)="showactive('internationaldid')"  [ngClass]="{'active': showingtab === 'internationaldid'}"
class="nav-link rounded-pill note-link d-flex align-items-center px-2 px-md-3 mr-0 mr-md-2"
id="snomIPPhones"> 
<span class="d-md-block">International DID price list</span></a>
</li>
</ul>

<div class="tab-content bg-transparent">
<div id="note-full-container" class="note-has-grid row">

<!---------------------
3cx Pricelist -USD -MYR
---------------------->
<div class="col-md-12 single-note-item HTekPhones" *ngIf='showingtab == "cxpricelist"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>3cx Pricelist -USD -MYR</h4>
</div>
<div class="card-body" >
<div class="table-responsive" *ngFor="let l of cxpricelist">

 
    <iframe  [src]="pdfview| safe: 'resourceUrl' " width="100%" height="1155px" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" allowfullscreen=""></iframe>

</div>
</div>
</div>
<!-- <div class="table-notes">
<p><b>Warranty :</b> 24 months warranty against manufacturing defects, excluding AC adapters and accessories</p>
</div> -->
</div>
</div>
</div>



<!---------------------
HTek Phones
---------------------->
<div class="col-md-12 single-note-item HTekPhones" *ngIf='showingtab == "HtekIPPhones"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>H-Tek IP Phones</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table success-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>

<th *ngIf="HtekIPPhones[0].data.rate_label_1  && currency_symbol_datas.length >= 1">{{HtekIPPhones[0].data.rate_label_1}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_2 && currency_symbol_datas.length >= 1">{{HtekIPPhones[0].data.rate_label_2}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_3 && currency_symbol_datas.length >= 1">{{HtekIPPhones[0].data.rate_label_3}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_4 && currency_symbol_datas.length >= 1">{{HtekIPPhones[0].data.rate_label_4}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_1 && currency_symbol_datas.length >= 2">{{HtekIPPhones[0].data.rate_label_1}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_2 && currency_symbol_datas.length >= 2">{{HtekIPPhones[0].data.rate_label_2}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_3 && currency_symbol_datas.length >= 2">{{HtekIPPhones[0].data.rate_label_3}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_4 && currency_symbol_datas.length >= 2">{{HtekIPPhones[0].data.rate_label_4}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_1 && currency_symbol_datas.length >= 3 ">{{HtekIPPhones[0].data.rate_label_1}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_2 && currency_symbol_datas.length >= 3">{{HtekIPPhones[0].data.rate_label_2}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_3 && currency_symbol_datas.length >= 3">{{HtekIPPhones[0].data.rate_label_3}}</th>
<th *ngIf="HtekIPPhones[0].data.rate_label_4 && currency_symbol_datas.length >= 3">{{HtekIPPhones[0].data.rate_label_4}}</th>


</tr>
</thead>
<tbody>
<tr  *ngFor="let l of HtekIPPhones;let c=index;">
<td class="text-center">{{c+1}}</td>
<td>{{l.data.productName}}</td>
<td>{{l.data.productDesc}}</td>

<td class="product-img"><img src="https://erp.cal4care.com/cms_new/images/product_img/uc902s1771685576-1581390115.jpg"></td>



 <td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*l.data.rate_1 | number: fractionSize }}</td>
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*l.data.rate_2 | number: fractionSize}}</td>
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*l.data.rate_3 | number: fractionSize}}</td>
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*l.data.rate_4 |  number: fractionSize}}</td> 

 <td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*l.data.rate_1 |  number: fractionSize}}</td>
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*l.data.rate_2 |  number: fractionSize}}</td>
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*l.data.rate_3 |  number: fractionSize}}</td>
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*l.data.rate_4 |  number: fractionSize}}</td> 

 <td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*l.data.rate_1 |  number: fractionSize}}</td>
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*l.data.rate_2 |  number: fractionSize}}</td>
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*l.data.rate_3 |  number: fractionSize}}</td>
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*l.data.rate_4 |  number: fractionSize}}</td> 

</tbody>
</table>
</div>
</div>
</div>
<div class="table-notes">
<p [innerHtml]="HtekIPPhones[0].data.footer_content"></p>
</div>
</div>
</div>
</div>
<!---------------------
HTek Phones End
---------------------->
<!---------------------
Headsets
---------------------->
<div class="col-md-12 single-note-item headsets" *ngIf='showingtab == "headsets"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Headsets</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table primary-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>

<th *ngIf="headsets[0].data.rate_label_1 && currency_symbol_datas.length >= 1">{{headsets[0].data.rate_label_1}}</th>
<th *ngIf="headsets[0].data.rate_label_2 && currency_symbol_datas.length >= 1">{{headsets[0].data.rate_label_2}}</th>

<th *ngIf="headsets[0].data.rate_label_1 && currency_symbol_datas.length >= 2">{{headsets[0].data.rate_label_1}}</th>
<th *ngIf="headsets[0].data.rate_label_2 && currency_symbol_datas.length >= 2">{{headsets[0].data.rate_label_2}}</th>

<th *ngIf="headsets[0].data.rate_label_1 && currency_symbol_datas.length >= 3">{{headsets[0].data.rate_label_1}}</th>
<th *ngIf="headsets[0].data.rate_label_2 && currency_symbol_datas.length >= 3">{{headsets[0].data.rate_label_2}}</th>

</tr>
</thead>
<tbody>
<tr *ngFor="let h of headsets;let d=index">
<td class="text-center">{{d+1}}</td>
<td>{{h.data.productName}}</td>
<td>{{h.data.productDesc}}</td>
<td class="product-img"><img src="{{url}}{{h.data.product_img_1}}"></td>


<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*h.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*h.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*h.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*h.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*h.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*h.data.rate_2 |  number: fractionSize}}</td> 

</tr>

</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
</div>
<!---------------------
Headsets End
---------------------->
<!---------------------
3CX Appliance
---------------------->
<div class="col-md-12 single-note-item 3CXAppliance" *ngIf='showingtab == "CXAPPLIANCE3CXSBC"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>3CX Appliance - 3CX SBC</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table ping-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>

<th *ngIf="CXAPPLIANCE3CXSBC[0].data.rate_label_1 && currency_symbol_datas.length >= 1">{{CXAPPLIANCE3CXSBC[0].data.rate_label_1}}</th>
<th *ngIf="CXAPPLIANCE3CXSBC[0].data.rate_label_2 && currency_symbol_datas.length >= 1">{{CXAPPLIANCE3CXSBC[0].data.rate_label_2}}</th>

<th *ngIf="CXAPPLIANCE3CXSBC[0].data.rate_label_1 && currency_symbol_datas.length >= 2">{{CXAPPLIANCE3CXSBC[0].data.rate_label_1}}</th>
<th *ngIf="CXAPPLIANCE3CXSBC[0].data.rate_label_2 && currency_symbol_datas.length >= 2">{{CXAPPLIANCE3CXSBC[0].data.rate_label_2}}</th>

<th *ngIf="CXAPPLIANCE3CXSBC[0].data.rate_label_1 && currency_symbol_datas.length >= 3">{{CXAPPLIANCE3CXSBC[0].data.rate_label_1}}</th>
<th *ngIf="CXAPPLIANCE3CXSBC[0].data.rate_label_2 && currency_symbol_datas.length >= 3">{{CXAPPLIANCE3CXSBC[0].data.rate_label_2}}</th>


</tr>
</thead>
<tbody>
<tr *ngFor="let g of CXAPPLIANCE3CXSBC;let n = index;">
<td class="text-center">{{n+1}}</td>
<td>{{g.data.productName}}</td>
<td>{{g.data.productDesc}}</td>
<td class="product-img"><img src="{{url}}{{g.data.product_img_1}}"></td>

<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*g.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*g.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*g.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*g.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*g.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*g.data.rate_2 |  number: fractionSize}}</td> 


</tr>

</tbody>
</table>
</div>
</div>

<div class="table-notes">
<p [innerHtml]="CXAPPLIANCE3CXSBC[0].data.footer_content"></p>
</div>

</div>
</div>
</div>
</div>
<!---------------------
3CX Appliance End
---------------------->
<!---------------------
Beronet Gateways
---------------------->
<div class="col-md-12 single-note-item beronetGateways" *ngIf='showingtab == "beronet"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Beronet Gateways</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table success-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>
<th *ngIf="beronet[0].data.rate_label_1 && currency_symbol_datas.length >= 1">{{beronet[0].data.rate_label_1}}</th>
<th *ngIf="beronet[0].data.rate_label_2 && currency_symbol_datas.length >= 1">{{beronet[0].data.rate_label_2}}</th>

<th *ngIf="beronet[0].data.rate_label_1 && currency_symbol_datas.length >= 2">{{beronet[0].data.rate_label_1}}</th>
<th *ngIf="beronet[0].data.rate_label_2 && currency_symbol_datas.length >= 2">{{beronet[0].data.rate_label_2}}</th>

<th *ngIf="beronet[0].data.rate_label_1 && currency_symbol_datas.length >= 3">{{beronet[0].data.rate_label_1}}</th>
<th *ngIf="beronet[0].data.rate_label_2 && currency_symbol_datas.length >= 3">{{beronet[0].data.rate_label_2}}</th>



</tr>
</thead>
<tbody>

<tr  *ngFor="let g of beronet;let n = index;">
<td class="text-center">2</td>
<td>{{g.data.productName}}</td>
<td>{{g.data.productDesc}}</td>
<td class="product-img"><img src="{{url}}{{g.data.product_img_1}}"></td>

<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*g.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*g.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*g.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*g.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*g.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*g.data.rate_2 |  number: fractionSize}}</td> 


</tr>
</tbody>
</table>
</div>
</div>

<div class="table-notes">
<p [innerHtml]="beronet[0].data.footer_content"></p>
</div>

</div>
</div>
</div>
</div>
<!---------------------
Beronet Gateways End
---------------------->
<!---------------------
Intercom PA System
---------------------->
<div class="col-md-12 single-note-item intercomPA" *ngIf='showingtab == "intercomspasystem"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Intercoms - PA system</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table primary-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>
</tr>
</thead>
<tbody>
<tr  *ngFor="let m of intercomspasystem;let n=index">
<td class="text-center">{{n+1}}</td>
<td>{{m.data.productName}}</td>
<td>{{m.data.productDesc}}</td>
<td class="product-img"><img src="{{url}}{{m.data.product_img_1}}"></td>
</tr>

</tbody>
</table>
</div>
</div>

<div class="table-notes">
<p [innerHtml]="intercomspasystem[0].data.footer_content"></p>
</div>

</div>
</div>
</div>
</div>
<!---------------------
Intercom PA System End
---------------------->
<!---------------------
Fax ATA 3CX
---------------------->
<div class="col-md-12 single-note-item faxATA" *ngIf='showingtab == "faxata"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Fax ATA-3CX</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table ping-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>


<th *ngIf="faxata3cx[0].data.rate_label_1 && currency_symbol_datas.length >= 1">{{faxata3cx[0].data.rate_label_1}}</th>
<th *ngIf="faxata3cx[0].data.rate_label_2 && currency_symbol_datas.length >= 1">{{faxata3cx[0].data.rate_label_2}}</th>

<th *ngIf="faxata3cx[0].data.rate_label_1 && currency_symbol_datas.length >= 2">{{faxata3cx[0].data.rate_label_1}}</th>
<th *ngIf="faxata3cx[0].data.rate_label_2 && currency_symbol_datas.length >= 2">{{faxata3cx[0].data.rate_label_2}}</th>

<th *ngIf="faxata3cx[0].data.rate_label_1 && currency_symbol_datas.length >= 3">{{faxata3cx[0].data.rate_label_1}}</th>
<th *ngIf="faxata3cx[0].data.rate_label_2 && currency_symbol_datas.length >= 3">{{faxata3cx[0].data.rate_label_2}}</th>


</tr>
</thead>
<tbody>
<tr *ngFor="let v of faxata3cx;let u= index;">
<td class="text-center">{{u+1}}</td>
<td>{{v.data.productName}}</td>
<td>{{v.data.productDesc}}</td>
<td class="product-img"><img src="{{url}}{{v.data.product_img_1}}"></td>

<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*v.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*v.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*v.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*v.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*v.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*v.data.rate_2 |  number: fractionSize}}</td> 


</tr>

</tbody>
</table>
</div>
</div>


<div class="table-notes">
<p [innerHtml]="faxata3cx[0].data.footer_content"></p>
</div>

</div>
</div>
</div>
</div>
<!---------------------
Fax ATA 3CX End
---------------------->
<!---------------------
Confierence Phone
---------------------->
<div class="col-md-12 single-note-item conferencePhone" *ngIf='showingtab == "conference"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Conference Phone - 3CX Web Meeting</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table success-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>

<th *ngIf="conferencephonewebmeeting[0].data.rate_label_1 && currency_symbol_datas.length >= 1">{{conferencephonewebmeeting[0].data.rate_label_1}}</th>
<th *ngIf="conferencephonewebmeeting[0].data.rate_label_2 && currency_symbol_datas.length >= 1">{{conferencephonewebmeeting[0].data.rate_label_2}}</th>

<th *ngIf="conferencephonewebmeeting[0].data.rate_label_1 && currency_symbol_datas.length >= 2">{{conferencephonewebmeeting[0].data.rate_label_1}}</th>
<th *ngIf="conferencephonewebmeeting[0].data.rate_label_2 && currency_symbol_datas.length >= 2">{{conferencephonewebmeeting[0].data.rate_label_2}}</th>

<th *ngIf="conferencephonewebmeeting[0].data.rate_label_1 && currency_symbol_datas.length >= 3">{{conferencephonewebmeeting[0].data.rate_label_1}}</th>
<th *ngIf="conferencephonewebmeeting[0].data.rate_label_2 && currency_symbol_datas.length >= 3">{{conferencephonewebmeeting[0].data.rate_label_2}}</th>


</tr>
</thead>
<tbody>

<tr *ngFor="let b of conferencephonewebmeeting;let c= index;">
<td class="text-center">{{c+1}}</td>
<td>{{b.data.productName}}</td>
<td>{{b.data.productDesc}}</td>
<td class="product-img"><img src="{{url}}{{b.data.product_img_1}}"></td>


<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*b.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*b.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*b.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*b.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*b.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*b.data.rate_2 |  number: fractionSize}}</td> 

</tr>

</table>
</div>
</div>

<div class="table-notes">
<p [innerHtml]="conferencephonewebmeeting[0].data.footer_content"></p>
</div>
</div>
</div>
</div>
</div>
<!---------------------
Confierence Phone End
---------------------->
<!---------------------
Confierence Phone
---------------------->
<div class="col-md-12 single-note-item hotelPhones" *ngIf='showingtab == "hotels"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>hotel Phones</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table primary-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>

<th *ngIf="hotelphones[0].data.rate_label_1 && currency_symbol_datas.length >= 1">{{hotelphones[0].data.rate_label_1}}</th>
<th *ngIf="hotelphones[0].data.rate_label_2 && currency_symbol_datas.length >= 1">{{hotelphones[0].data.rate_label_2}}</th>

<th *ngIf="hotelphones[0].data.rate_label_1 && currency_symbol_datas.length >= 2">{{hotelphones[0].data.rate_label_1}}</th>
<th *ngIf="hotelphones[0].data.rate_label_2 && currency_symbol_datas.length >= 2">{{hotelphones[0].data.rate_label_2}}</th>

<th *ngIf="hotelphones[0].data.rate_label_1 && currency_symbol_datas.length >= 3">{{hotelphones[0].data.rate_label_1}}</th>
<th *ngIf="hotelphones[0].data.rate_label_2 && currency_symbol_datas.length >= 3">{{hotelphones[0].data.rate_label_2}}</th>



</tr>
</thead>
<tbody>
<!-- <tr>
<td class="text-center">1</td>
<td>H2S</td>
<td>Fanvil Entry-level Hotel SIP phone. Wall-mountable, no display. POE</td>
<td class="product-img"><img src="https://erp.cal4care.com/cms_new/images/product_img/h2s-1556608867.jpg"></td>
<td>S$ 120.00</td>
<td>S$ 100.00</td>
<td>US $ 90.84</td>
<td>US $ 75.70</td>
</tr> -->

<tr *ngFor="let hh of hotelphones;let x= index;">
<td class="text-center">{{x+1}}</td>
<td>{{hh.data.productName}}</td>
<td>{{hh.data.productDesc}}</td>
<td class="product-img"><img src="{{url}}{{hh.data.product_img_1}}"></td>
<!-- <td>{{hh.data.rate_1}}</td>
<td>{{hh.data.rate_2}}</td>
<td>{{hh.data.rate_3}}</td>
<td>{{hh.data.rate_4}}</td> -->

<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*hh.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*hh.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*hh.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*hh.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*hh.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*hh.data.rate_2 |  number: fractionSize}}</td> 




</tr>

<!-- <tr>
<td class="text-center">2</td>
<td>H3</td>
<td>Fanvil H3 Hotel SIP Phone, 1 SIP account, 6 Soft keys programmable</td>
<td class="product-img"><img src="https://erp.cal4care.com/cms_new/images/product_img/h3-1556608874.jpg"></td>
<td>S$ 140.00</td>
<td>S$ 120.00</td>
<td>US $ 105.98</td>
<td>US $ 90.84</td>
</tr> -->
</tbody>
</table>
</div>
</div>
<!-- <div class="table-notes">
<p>* CONFERENCE PHONE ARE TESTED WITH HOTDESKING </p>
<p>* ANDROID CONFERENCE WEBMEETING SUPPORTED TESTED AGRESSIVELY IN CAL4CARE LABS </p>
</div> -->
<div class="table-notes">
<p [innerHtml]="hotelphones[0].data.footer_content"></p>
</div>

</div>
</div>
</div>
</div>
<!---------------------
hotel Phones End
---------------------->

<!---------------------
SIPTRUNKS- LOCAL 
---------------------->
<div class="col-md-12 single-note-item headsets" *ngIf='showingtab == "siptrunk"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>SIPTRUNKS- LOCAL
</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table primary-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>

<th *ngIf="siptrunkslocal[0].data.rate_label_1 && currency_symbol_datas.length >= 1">{{siptrunkslocal[0].data.rate_label_1}}</th>
<th *ngIf="siptrunkslocal[0].data.rate_label_2 && currency_symbol_datas.length >= 1">{{siptrunkslocal[0].data.rate_label_2}}</th>

<th *ngIf="siptrunkslocal[0].data.rate_label_1 && currency_symbol_datas.length >= 2">{{siptrunkslocal[0].data.rate_label_1}}</th>
<th *ngIf="siptrunkslocal[0].data.rate_label_2 && currency_symbol_datas.length >= 2">{{siptrunkslocal[0].data.rate_label_2}}</th>

<th *ngIf="siptrunkslocal[0].data.rate_label_1 && currency_symbol_datas.length >= 3">{{siptrunkslocal[0].data.rate_label_1}}</th>
<th *ngIf="siptrunkslocal[0].data.rate_label_2 && currency_symbol_datas.length >= 3">{{siptrunkslocal[0].data.rate_label_2}}</th>

</tr>
</thead>
<tbody>
<tr *ngFor="let h of siptrunkslocal;let d=index">
<td class="text-center">{{d+1}}</td>
<td>{{h.data.productName}}</td>
<td>{{h.data.productDesc}}</td>
<td class="product-img"><img src="{{url}}{{h.data.product_img_1}}"></td>


<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*h.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 1">{{currency_symbol_datas[0].symbol}} {{currency_symbol_val[0].val*h.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*h.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 2">{{currency_symbol_datas[1].symbol}} {{currency_symbol_val[1].val*h.data.rate_2 |  number: fractionSize}}</td> 

<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*h.data.rate_1 |  number: fractionSize}}</td> 
<td *ngIf="currency_symbol_datas.length >= 3">{{currency_symbol_datas[2].symbol}} {{currency_symbol_val[2].val*h.data.rate_2 |  number: fractionSize}}</td> 

</tr>

</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
</div>
<!---------------------
SIPTRUNKS- LOCAL End
---------------------->






<!---------------------
Snom Phone
---------------------->
<div class="col-md-12 single-note-item snomIPPhones" *ngIf='showingtab == "yealink"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Yealink</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table success-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th class="text-center">S.No</th>
<th>Product Name</th>
<th>Description</th>
<th>Image</th>
<th>MSRP</th>
<th>> 1 Qty</th>
<th>> 10 Qty</th>
<th>> 100 Qty</th>
<th>MSRP</th>
<th>> 1 Qty</th>
<th>> 10 Qty</th>
<th>> 100 Qty</th>
<th>MSRP</th>
<th>> 1 Qty</th>
<th>> 10 Qty</th>
<th>> 100 Qty</th>
</tr>
</thead>
<tbody>
<!--  <tr>
<td class="text-center">1</td>
<td>SNM_M325-EU</td>
<td>3955 - Snom M325 SingleCell IP DECT Bundle (DE) MSRP Price quoted for minimum 5 units</td>
<td class="product-img"><img src="https://erp.cal4care.com/cms_new/images/product_img/snom_m325-1557743971.jpg"></td>
<td>S$ 260.00</td>
<td>S$ 0.00</td>
<td>S$ 0.00</td>
<td>S$ 0.00</td>
<td>US $ 196.82</td>
<td>US $ 0.00</td>
<td>US $ 0.00</td>
<td>US $ 0.00</td>
</tr>  -->

<tr *ngFor="let hg of yealink;let p= index;">
<td class="text-center">{{p+1}}</td>
<td>{{hg.data.productName}}</td>
<td>{{hg.data.productDesc}}</td>
<td class="product-img"><img src="{{url}}{{hg.data.product_img_1}}"></td>
<td>{{hg.data.rate_1}}</td>
<td>{{hg.data.rate_2}}</td>
<td>{{hg.data.rate_3}}</td>
<td>{{hg.data.rate_4}}</td>

<td>{{hg.data.rate_1}}</td>
<td>{{hg.data.rate_2}}</td>
<td>{{hg.data.rate_3}}</td>
<td>{{hg.data.rate_4}}</td>

<td>{{hg.data.rate_1}}</td>
<td>{{hg.data.rate_2}}</td>
<td>{{hg.data.rate_3}}</td>
<!-- <td>{{hg.data.rate_4}}</td> -->
</tr>
<!-- <tr>
<td class="text-center">2</td>
<td>SNM_M85</td>
<td>4189 - Snom M85 Industrial Handset EU/US MSRP Price quoted for minimum 5 units</td>
<td class="product-img"><img src="https://erp.cal4care.com/cms_new/images/product_img/snom_m65-1557744163.jpg"></td>
<td>S$ 260.00</td>
<td>S$ 0.00</td>
<td>S$ 0.00</td>
<td>S$ 0.00</td>
<td>US $ 196.82</td>
<td>US $ 0.00</td>
<td>US $ 0.00</td>
<td>US $ 0.00</td>
</tr> -->
</tbody>
</table>
</div>
</div>
<!-- <div class="table-notes">
<p>* CONFERENCE PHONE ARE TESTED WITH HOTDESKING </p>
<p>* ANDROID CONFERENCE WEBMEETING SUPPORTED TESTED AGRESSIVELY IN CAL4CARE LABS </p>
</div> -->
<!-- <div class="table-notes">
<p [innerHtml]="yealink[0].data.footer_content"></p>
</div> -->


</div>
</div>
</div>
</div>
<!---------------------
Snom Phones End
---------------------->
<!---------------------
3CX Cloud SG Hosting
---------------------->
<div class="col-md-12 single-note-item 3cxCloudHosting" *ngIf='showingtab == "3cxcloudsg"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Standard Edition</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table success-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th *ngFor="let j of callheader">{{j.data.setting_value}}</th>
<!-- <th>Compare</th> -->
</tr>
</thead>
<tbody>

<tr  *ngFor="let j of cloud_sg_call_details_stnd">
	<!-- <div *ngIf='j.data.model_type_id == "1"'> -->
<td>{{j.data.product_edition_name}}</td>
<td>{{j.data.sim_calls}}</td>
<td>{{j.data.max_extension_allwoed}}</td>
<!-- <td>{{j.data.max_extension_allwoed}}</td> -->
<td [innerHtml]="j.data.min_contract_period"></td>
<!-- <td>{{j.data.session_border_onsite}}</td> -->
<td>
 <img  alt="image" *ngIf="j.data.session_border_onsite == '1'" src="assets/img/tick.png" width="35">&nbsp;
                     <img alt="image" *ngIf="j.data.session_border_onsite =='0'" src="assets/img/cross.png" width="35">&nbsp; 
                 </td>
<td>{{j.data.set_charge_val}}</td>
<td [innerHtml]="j.data.monthly_subscreption"></td>
<!-- <td><a href="https://www.calncall.com/feature-comparison/" class="btn btn-success" target="_blank">Compare</a></td> -->
</tr>

</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Pro Edition</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table ping-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th *ngFor="let j of callheader">{{j.data.setting_value}}</th>
	
<th>Compare</th>
</tr>
</thead>
<tbody>

<tr  *ngFor="let j of cloud_sg_call_details_prof">
<td>{{j.data.product_edition_name}}</td>
<td>{{j.data.sim_calls}}</td>
<td>{{j.data.max_extension_allwoed}}</td>
<!-- <td>{{j.data.max_extension_allwoed}}</td> -->
<td [innerHtml]="j.data.min_contract_period"></td>
<!-- <td>{{j.data.session_border_onsite}}</td> -->
<td>
 <img  alt="image" *ngIf="j.data.session_border_onsite == '1'" src="assets/img/tick.png" width="35">&nbsp;
                     <img alt="image" *ngIf="j.data.session_border_onsite =='0'" src="assets/img/cross.png" width="35">&nbsp; 
                 </td>
<td>{{j.data.set_charge_val}}</td>
<td [innerHtml]="j.data.monthly_subscreption"></td>

<td><a href="https://www.calncall.com/feature-comparison/" class="btn btn-success" target="_blank">Compare</a></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
</div>
<!---------------------
3CX Cloud SG Hosting End
---------------------->

<!---------------------
3CX Cloud MY Hosting
---------------------->
<div class="col-md-12 single-note-item 3cxCloudHosting" *ngIf='showingtab == "3cxcloudmy"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Standard Edition</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table success-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th *ngFor="let j of cloudheader">{{j.data.setting_value}}</th>
<th>Compare</th>
</tr>
</thead>
<tbody>

<tr  *ngFor="let j of cloud_my_cloud_details_stnd">
	<!-- <div *ngIf='j.data.model_type_id == "1"'> -->
<td>{{j.data.product_edition_name}}</td>
<td>{{j.data.sim_calls}}</td>
<td>{{j.data.max_extension_allwoed}}</td>
<!-- <td>{{j.data.max_extension_allwoed}}</td> -->
<td [innerHtml]="j.data.min_contract_period"></td>
<!-- <td>{{j.data.session_border_onsite}}</td> -->
<td>
 <img  alt="image" *ngIf="j.data.session_border_onsite == '1'" src="assets/img/tick.png" width="35">&nbsp;
                     <img alt="image" *ngIf="j.data.session_border_onsite =='0'" src="assets/img/cross.png" width="35">&nbsp; 
                 </td>
<td>{{j.data.set_charge_val}}</td>
<td [innerHtml]="j.data.monthly_subscreption"></td>
<td><a href="http://www.callacloud.com/features-comparison/" class="btn btn-success" target="_blank">Compare</a></td>
</tr>

</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Pro Edition</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table ping-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th *ngFor="let j of cloudheader">{{j.data.setting_value}}</th>
	
<th>Compare</th>
</tr>
</thead>
<tbody>

<tr  *ngFor="let j of cloud_my_cloud_details_prof">
<td>{{j.data.product_edition_name}}</td>
<td>{{j.data.sim_calls}}</td>
<td>{{j.data.max_extension_allwoed}}</td>
<!-- <td>{{j.data.max_extension_allwoed}}</td> -->
<td [innerHtml]="j.data.min_contract_period"></td>
<!-- <td>{{j.data.session_border_onsite}}</td> -->
<td>
<img  alt="image" *ngIf="j.data.session_border_onsite == '1'" src="assets/img/tick.png" width="35">&nbsp;
                     <img alt="image" *ngIf="j.data.session_border_onsite =='0'" src="assets/img/cross.png" width="35">&nbsp; 
                 </td>
<td>{{j.data.set_charge_val}}</td>
<td [innerHtml]="j.data.monthly_subscreption"></td>

<td><a href="http://www.callacloud.com/features-comparison/" class="btn btn-success" target="_blank">Compare</a></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
</div>
<!---------------------
3CX Cloud MY Hosting End
---------------------->

<!---------------------
3CX Cloud THB Hosting
---------------------->
<div class="col-md-12 single-note-item 3cxCloudHosting" *ngIf='showingtab == "3cxcloudthb"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Standard Edition</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table success-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th *ngFor="let j of clearheader">{{j.data.setting_value}}</th>
<th>Compare</th>
</tr>
</thead>
<tbody>

<tr  *ngFor="let j of cloud_thb_clear_details_stnd">
	<!-- <div *ngIf='j.data.model_type_id == "1"'> -->
<td>{{j.data.product_edition_name}}</td>
<td>{{j.data.sim_calls}}</td>
<td>{{j.data.max_extension_allwoed}}</td>
<!-- <td>{{j.data.max_extension_allwoed}}</td> -->
<td [innerHtml]="j.data.min_contract_period"></td>
<!-- <td>{{j.data.session_border_onsite}}</td> -->
<td>
<img  alt="image" *ngIf="j.data.session_border_onsite == '1'" src="assets/img/tick.png" width="35">&nbsp;
                     <img alt="image" *ngIf="j.data.session_border_onsite =='0'" src="assets/img/cross.png" width="35">&nbsp; 
                 </td>
<td>{{j.data.set_charge_val}}</td>
<td [innerHtml]="j.data.monthly_subscreption"></td>
<td><a href="https://www.calncall.com/feature-comparison/" class="btn btn-success" target="_blank">Compare</a></td>
</tr>

</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>Pro Edition</h4>
</div>
<div class="card-body">
<div class="table-responsive">
<table class="table ping-color-table product-list-table color-table table-striped table-hover">
<thead>
<tr>
<th *ngFor="let j of clearheader">{{j.data.setting_value}}</th>
	
<th>Compare</th>
</tr>
</thead>
<tbody>

<tr  *ngFor="let j of cloud_thb_clear_details_prof">
<td>{{j.data.product_edition_name}}</td>
<td>{{j.data.sim_calls}}</td>
<td>{{j.data.max_extension_allwoed}}</td>
<!-- <td>{{j.data.max_extension_allwoed}}</td> -->
<td [innerHtml]="j.data.min_contract_period"></td>
<!-- <td >{{j.data.session_border_onsite}}</td> -->
<td>
 <img  alt="image" *ngIf="j.data.session_border_onsite == '1'" src="assets/img/tick.png" width="35">&nbsp;
                     <img alt="image" *ngIf="j.data.session_border_onsite =='0'" src="assets/img/cross.png" width="35">&nbsp; 
                 </td>
<td>{{j.data.set_charge_val}}</td>
<td [innerHtml]="j.data.monthly_subscreption"></td>

<td><a href="https://www.calncall.com/feature-comparison/" class="btn btn-success" target="_blank">Compare</a></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
</div>
<!---------------------
3CX Cloud THB Hosting End
---------------------->






<!---------------------
International DID List
---------------------->
<div class="col-md-12 single-note-item HTekPhones" *ngIf='showingtab == "internationaldid"'>
<div class="note-card">
<div class="note-content">
<div class="card">
<div class="card-header">
<h4>International DID List</h4>
</div>
<div class="card-body" >
<div class="table-responsive" *ngFor="let l of internationaldidprice">
<!-- <embed src='https://erp.cal4care.com/cms_new/images/product_img/+{{reseller_product_details[0].data.product_img_1}} | safe' 
    style="width: 100%;height: 500px" 
    type="application/pdf"> -->
<!-- <pdf-viewer [src]="pdfSource"
              [original-size]="false"
  ></pdf-viewer> -->
 
    <iframe  [src]="pdfviews| safe: 'resourceUrl' " width="100%" height="1155px" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" allowfullscreen=""></iframe>

</div>
</div>
</div>
<!-- <div class="table-notes">
<p><b>Warranty :</b> 24 months warranty against manufacturing defects, excluding AC adapters and accessories</p>
</div> -->
</div>
</div>
</div>
<!---------------------
International DID List End
---------------------->


</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

</div>
</section>